<template style="text-align: justify">
  <v-card style="padding: 10px" class="rounded-xl" color="white" elevation="5" dark>
    <div>
      <div v-if="privacyText">
        <v-card-text v-html="privacyText" class="colorT flex-grow-0 flex-shrink-1" />
      </div>

      <div v-if="!privacyText">
        <v-card-text>
          <span class="colorT flex-grow-0 flex-shrink-1">
            <p class="text-right">Ultima revisión: 10 de octubre de 2020</p>
            <p>
              El presente aviso de privacidad, se emite cumpliendo por lo dispuesto por el artículo 15 de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares publicada el
              5 de julio de 2010 en el Diario Oficial de la Federación, y se pone a disposición de los usuarios que entreguen datos o información personal a
              <span class="font-weight-black"> KONECT LOGÍSTICA INTEGRADA, S.A. DE C.V.</span>
            </p>

            <p>
              En nuestro carácter de responsables en el tratamiento de datos personales observamos los principios que marca la ley, de licitud, consentimiento, información, calidad, finalidad,
              lealtad, proporcionalidad y responsabilidad.
            </p>
            <p></p>

            <p>
              Las Condiciones de uso regulan el acceso o uso que usted haga, como persona, desde cualquier parte de la ciudad de aplicaciones, páginas web, contenido, productos y servicios puestos a
              disposición por KONECT, una sociedad de responsabilidad constituida en México, con domicilio social en Calle Roma número 16, en la Colonia Mirador, en el Centro de Monterrey Nuevo León,
              con Código Postal 64910.
            </p>
          </span>
        </v-card-text>
        <v-card-title class="headline pl-5 font-weight-bold">RECOPILACIÓN DE INFORMACIÓN</v-card-title>
        <v-card-text>
          <span class="colorT text-md-justify">
            <p>
              Relacionada con las Aplicaciones: Podemos recopilar información acerca de su dispositivo, software, conexión y uso de Aplicaciones a los fines de operar o mejorar nuestras Aplicaciones o
              las características relacionadas con las Aplicaciones. Esta información puede incluir datos personales que usted haya ingresado en la Aplicación, como su ID en línea o dirección de
              correo electrónico. En la mayoría de los casos, la Aplicación recopila pasivamente la información relacionada con las Aplicaciones. Si bien esta información puede incluir un
              identificador personal, como una ID de dispositivo, o bien puede estar asociada con un identificador personal, la información suele utilizarse en conjunto. No obstante, algunas
              Aplicaciones o características relacionadas con las Aplicaciones pueden usar esta información de manera tal que sea personalmente identificable. Por ejemplo, se puede usar su ID en línea
              en conjunto con datos de eventos de juegos, como su puntuación más alta, para conformar un tablero con los puntajes más altos de la comunidad. Además, algunas Aplicaciones pueden incluir
              características que le permitan hacer públicos sus datos personales, como chat.
            </p>

            <p>
              Servicio comercial: Podemos recopilar información con fines de compra, registro, asistencia técnica u otros fines de servicio comercial. Esta información suele consistir en datos
              ingresados por usted, como su nombre, dirección de correo electrónico, fecha de nacimiento, datos de contacto o datos de tarjeta de pago, pero también puede incluir información
              recopilada por la Aplicación de manera pasiva, como datos sobre su dispositivo, software o conexión. La información que recopilamos pasivamente no suele considerarse personal, pero puede
              incluir identificadores de aplicación, de dispositivo u otros, o combinarse con ellos.
            </p>

            <p>
              Mediante su acceso y uso de los Servicios usted acuerda vincularse jurídicamente por estas Condiciones, que establecen una relación contractual entre usted y KONECT. Si usted no acepta
              estas Condiciones, no podrá acceder o usar los Servicios. Estas Condiciones sustituyen expresamente los acuerdos o compromisos previos con usted. KONECT podrá poner fin de inmediato a
              estas Condiciones o cualquiera de los Servicios respecto de usted o, en general, dejar de ofrecer o denegar el acceso a los Servicios o cualquier parte de ellos, en cualquier momento y
              por cualquier motivo.
            </p>

            <p>
              Se podrán aplicar condiciones suplementarias a determinados Servicios, como políticas para un evento, una actividad o una promoción particular, y dichas condiciones suplementarias se le
              comunicarán en relación con los Servicios aplicables. Las condiciones suplementarias se establecen además de las Condiciones, y se considerarán una parte de estas, para los fines de los
              Servicios aplicables. Las condiciones suplementarias prevalecerán sobre las Condiciones en el caso de conflicto con respecto a los Servicios aplicables.
            </p>

            <p>
              KONECT podrá modificar las Condiciones relativas a los Servicios cuando lo considere oportuno. Las modificaciones serán efectivas después de la publicación por parte de KONECT de dichas
              Condiciones actualizadas en esta ubicación o las políticas modificadas o condiciones suplementarias sobre el Servicio aplicable. Su acceso o uso continuado de los Servicios después de
              dicha publicación constituye su consentimiento a vincularse por las Condiciones y sus modificaciones.
            </p>

            <p>
              La recopilación y el uso que hacemos de la información personal en relación con los Servicios son conforme se dispone en la Política de privacidad de KONECT, disponible en
              <a :href="`${web}`" class="link">{{ web }}</a>
            </p>
          </span>
        </v-card-text>

        <v-card-title class="headline pl-5 font-weight-bold">USO DE LA INFORMACIÓN </v-card-title>
        <v-card-text>
          <span class="colorT text-md-justify">
            <p>
              La información se utiliza con los fines para los cuales se recopiló. Por ejemplo, la información recopilada con fines relacionados con las Aplicaciones se utiliza para operar o mejorar
              nuestras Aplicaciones o las características relacionadas con las Aplicaciones, y aquella información recopilada con fines de servicio comercial se utiliza para los respectivos procesos
              de servicio comercial y las funciones de servicio comercial relacionadas. La información recopilada también podrá utilizarse para estudios demográficos, de mercado u otros estudios
              internos. Sin embargo, le enviaremos ofertas promocionales únicamente si usted aceptó recibirlas.
            </p>

            <p>
              Usted es responsable de obtener el acceso a la red de datos necesario para utilizar los Servicios. Podrán aplicarse las tarifas y tasas de datos y mensajes de su red móvil si usted
              accede o utiliza los Servicios desde un dispositivo inalámbrico y usted será responsable de dichas tarifas y tasas. Usted es responsable de adquirir y actualizar el hardware compatible o
              los dispositivos necesarios para acceder y utilizar los Servicios y Aplicaciones y cualquier actualización de estos. KONECT no garantiza que los Servicios, o cualquier parte de estos,
              funcionen en cualquier hardware o dispositivo particular. Además, los Servicios podrán ser objeto de disfunciones o retrasos inherentes al uso de Internet y de las comunicaciones
              electrónicas.
            </p>
          </span>
        </v-card-text>

        <v-card-title class="headline pl-5 font-weight-bold">DIVULGACIÓN DE LA INFORMACIÓN </v-card-title>
        <v-card-text>
          <span class="colorT text-md-justify">
            <p>
              Podemos compartir información con otras empresas del grupo “Jetty” para estudios demográficos, de mercado u otros estudios internos, o con fines promocionales. Podemos compartir
              información con terceros que nos asistan en la concreción de los fines antedichos. Por ejemplo, podemos divulgar información sobre avance en los juegos y un identificador de aplicación o
              dispositivo a un proveedor de servicios con fines de agrupación o análisis, o podemos divulgar datos de tarjeta de crédito a un procesador de pagos para completar su compra. No
              compartimos información con terceros no relacionados para sus propios fines promocionales independientes si usted no nos presta su consentimiento. Si se vende un negocio, podremos
              transferir información a la entidad compradora o adquirente. Podemos compartir información con agencias del orden público u organismos regulatorios según lo exija o lo permita la ley.
            </p>
          </span>
        </v-card-text>

        <v-card-title class="headline pl-5 font-weight-bold">USUARIOS MENORES DE EDAD </v-card-title>
        <v-card-text>
          <span class="colorT text-md-justify">
            <p>
              Si tomamos conocimiento de que un usuario es menor de edad, o en otros casos según lo exija la ley, podemos negarle a dicho usuario el acceso a la Aplicación, borrar la información del
              usuario y/o intentar notificar a los padres y obtener su consentimiento para recopilar, utilizar y divulgar la información personal del usuario.
            </p>

            <p>
              El Servicio no está disponible para el uso de personas menores de 18 años. Usted no podrá autorizar a terceros a utilizar su Cuenta, asimismo no podrá permitir a personas menores de 18
              años que reciban servicios de transporte privado o logísticos de Terceros proveedores, a menos que aquellos sean acompañados por usted. No podrá ceder o transferir de otro modo su Cuenta
              a cualquier otra persona o entidad. Usted acuerda cumplir con todas las leyes aplicables al utilizar los Servicios y solo podrá utilizar los Servicios con fines legítimos (p. ej., no
              para el transporte de materiales ilegales o peligrosos). En el uso de los Servicios, no causará estorbos, molestias, incomodidades o daños a la propiedad, tanto al Tercero proveedor como
              a cualquier otra parte. En algunos casos, se le podrá requerir que facilite un documento de identidad u otro elemento de verificación de identidad para el acceso o uso de los Servicios,
              y usted acepta que se le podrá denegar el acceso o uso de los Servicios si se niega a facilitar el documento de identidad o el elemento de verificación de identidad.
            </p>
          </span>
        </v-card-text>

        <v-card-title class="headline pl-5 font-weight-bold">MEDIDAS DE PROTECCIÓN</v-card-title>
        <v-card-text>
          <span class="colorT text-md-justify">
            <p>
              Tomamos medidas razonables para proteger la confidencialidad, la seguridad y la integridad de la información personal que se recopila de los usuarios de nuestras Aplicaciones, entre las
              que se incluyen medidas de protección contra pérdidas, abusos o alteraciones de la información que se encuentra bajo nuestro control, y medidas para divulgar esa información
              exclusivamente a quienes tengan la capacidad de mantener su confidencialidad, seguridad e integridad. La información recopilada mediante esta Aplicación se podrá almacenar en los Estados
              Unidos y conservar hasta que se cumpla el propósito de recopilación o uso, o hasta que haya transcurrido el período de retención obligatorio. Aunque nos esforzamos por proteger la
              información de identificación personal, no podemos asegurar ni garantizar la seguridad de la información transmitida a través de nuestras Aplicaciones o en relación con ellas.
            </p>
          </span>
        </v-card-text>

        <v-card-title class="headline pl-5 font-weight-bold">DATOS DE CONTACTO Y DERECHOS DE PRIVACIDAD EN CALIFORNIA</v-card-title>
        <v-card-text>
          <span class="colorT text-md-justify">
            <p>
              Para obtener información sobre nuestras prácticas de manejo de la información, o para saber cómo acceder a la información personal que podamos haber recopilado de usted y corregirla o
              actualizarla y, en el caso de los residentes del estado de California, para obtener información acerca de la divulgación de información a terceros para sus fines directos de promoción
              durante el año calendario anterior, comuníquese con nosotros por los siguientes medios:
            </p>

            <p>
              <a :href="`mailto:${email}`" class="link">{{ email }}</a>
            </p>
          </span>
        </v-card-text>

        <v-card-title class="headline pl-5 font-weight-bold">CAMBIOS EN NUESTRO AVISO DE PRIVACIDAD</v-card-title>
        <v-card-text>
          <span class="colorT text-md-justify">
            <p>
              Nos reservamos el derecho de realizar cambios en este aviso de privacidad en cualquier momento. Si realizamos un cambio sustancial en este aviso, lo notificaremos con un aviso en el
              encabezado del presente aviso. Si continúa utilizando una Aplicación sujeta a este aviso, esto significará que acepta los cambios implementados.
            </p>

            <p>
              Los servicios que se proporcionan por parte KONECT; este renuncia a toda declaración de garantía, expresa, implícita o estatuaria, no expresamente establecida en estas condiciones,
              incluidas las garantías implícitas de comercialidad, idoneidad para un fin en particular y no violación. Además, Konect no hace declaración ni presta garantía alguna relativa a la
              fiabilidad, puntualidad, calidad, o disponibilidad de los servicios o cualquiera de los servicios o bienes solicitados a través del uso de los servicios, o que los servicios no serán
              interrumpidos o estarán libres de errores.
            </p>

            <p>
              No podrá ceder ni transferir estas Condiciones, en todo o en parte, sin el consentimiento previo por escrito de KONECT. Usted da su aprobación a Konect para ceder o transferir estas
              Condiciones, en todo o en parte, incluido a: (i) una subsidiaria o un afiliado; (ii) un adquirente del capital, del negocio o de los activos de Konect; o (iii) un sucesor por fusión. No
              existe entre usted, Konect o cualquier Tercer proveedor una empresa conjunta o relación de socios, empleo o agencia como resultado del contrato entre usted y Konect o del uso de los
              Servicios.
            </p>

            <p>
              Si cualquier disposición de estas Condiciones se considerara ilegal, nula o inexigible, ya sea en su totalidad o en parte, de conformidad con cualquier legislación, dicha disposición o
              parte de esta se considerará que no forma parte de estas Condiciones, aunque la legalidad, validez y exigibilidad del resto de las disposiciones de estas Condiciones no se verá afectada.
              En ese caso, las partes deberán reemplazar dicha disposición ilegal, nula o inexigible, en todo o en parte por una disposición legal, válida y exigible que tenga, en la medida de lo
              posible, un efecto similar al que tenía la disposición ilegal, nula o inexigible, dados los contenidos y el propósito de estas Condiciones. Estas Condiciones constituyen el contrato
              íntegro y el entendimiento entre las partes en relación con el objeto y sustituye y reemplaza a todos los contratos o acuerdos anteriores o contemporáneos en relación con dicho objeto.
              En estas Condiciones, las palabras “incluido/a/os/as” e “incluye/n” significan “incluido, de forma meramente enunciativa”.
            </p>
          </span>
        </v-card-text>
      </div>
    </div>
  </v-card>
</template>

<script>
const props = {
  privacyText: {
    default: null,
    type: String,
  },
};
export default {
  data: () => ({
    email: "administracion@konectonline.com.mx",
    web: "https://konectonline.com.mx",
  }),
  props: props,
};
</script>

<style scoped>
.v-center {
  padding: 30px;
}
.colorT {
  color: rgb(0, 0, 0) !important;
  text-align: justify !important;
  text-justify: auto;
  justify-content: center !important;
}
a {
  color: #e22d86 !important;
}
</style>
